import {otsBaseApi} from "../../ots-api";
import {MeterFlowReading, MeterFlowReadingSearchCriteria,} from "../../../model/meter-flow-reading";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["MeterFlowReadings"]});

const meterFlowReadingApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchMeterFlowReadings: builder.query<
      MeterFlowReading[],
      MeterFlowReadingSearchCriteria
    >({
      query: (criteria) => ({
        url: `/meter-flow-readings/search`,
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "MeterFlowReadings", id} as const)),
            {type: "MeterFlowReadings", id: "LIST"}
          ];
        } else {
          return [{type: "MeterFlowReadings", id: "LIST"}];
        }
      },
    }),
    getMeterFlowReading: builder.query<MeterFlowReading, string>({
      query: (id) => ({
        url: `/meter-flow-readings/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "MeterFlowReadings", id}]
    }),
    createMeterFlowReading: builder.mutation<MeterFlowReading, Partial<MeterFlowReading>>({
      query: (mapping) => ({
        url: "/meter-flow-readings",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "MeterFlowReadings", id: "LIST"}]
    }),
    updateMeterFlowReading: builder.mutation<MeterFlowReading, Partial<MeterFlowReading>>({
      query: (mapping) => ({
        url: "/meter-flow-readings",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "MeterFlowReadings", id}]
    }),
    deleteMeterFlowReading: builder.mutation<void, Partial<MeterFlowReading>>({
      query: (mapping) => ({
        url: "/meter-flow-readings",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "MeterFlowReadings", id}]
    }),
  })
});

export const {
  useSearchMeterFlowReadingsQuery,
  useGetMeterFlowReadingQuery,
  useCreateMeterFlowReadingMutation,
  useUpdateMeterFlowReadingMutation,
  useDeleteMeterFlowReadingMutation,
} = meterFlowReadingApi;
